import type { ReactNode } from 'react';

import { useCustomerApiAuthInterceptor } from 'hooks/useCustomerApiAuthInterceptor';

type Props = {
  children: ReactNode;
};

export const CustomerApiAuthInterceptor = ({ children }: Props) => {
  useCustomerApiAuthInterceptor();

  return <>{children}</>;
};
